import CompaniesView from "../CompaniesView.vue";
import RolesList from "../Pages/RolesList.vue";
import RolesEditor from "../Pages/RolesEditor.vue";

const routes = [
  {
    path: '/cargos',
    component: CompaniesView,
    children: [
      {
        path: '',
        name: 'roles-list',
        component: RolesList,
      },
      {
        path: 'crear',
        name: 'roles-create',
        component: RolesEditor,
      },
      {
        path: ':id',
        name: 'roles-edit',
        component: RolesEditor
      },
    ]
  }
]

export default routes
